export class Supplier {
  constructor(
    public ID: number,
    public Name: string,
    public Discount: number,
    public IsDeleted: boolean,
  ) { }
}
